import { cx } from '@chakra-ui/utils';
import { useContext } from 'react';
import type {
  IndicatorProps as ReactSelectIndicatorProps,
  OptionTypeBase,
} from 'react-select';

import { Center, type CenterProps } from '@frontend/components';
import { ChevronDownIcon } from '@frontend/components/src/components/mediaAndIcons/icons/iconSet';

import { SelectContext } from '../SelectContext';
import { useSelectStyles } from '../SelectStylesContext';
import { BASE_CLASS_NAME } from '../const';

export type DropdownIndicatorProps<
  OptionType extends OptionTypeBase,
  IsMulti extends boolean,
> = ReactSelectIndicatorProps<OptionType, IsMulti> & {
  innerProps: CenterProps;
};

export const DropdownIndicator = <
  OptionType extends OptionTypeBase,
  IsMulti extends boolean,
>({
  innerProps,
}: DropdownIndicatorProps<OptionType, IsMulti>) => {
  const { dropdownIndicator: dropdownIndicatorStyles } = useSelectStyles();

  const { hasSuggestions, hasAcceptedSuggestions, hasRejectedSuggestions } =
    useContext(SelectContext);

  return (
    <Center
      {...innerProps}
      className={cx(
        `${BASE_CLASS_NAME}__dropdown-indicator`,
        innerProps.className,
      )}
      __css={{
        ...dropdownIndicatorStyles,
        ...(hasSuggestions && !hasAcceptedSuggestions && !hasRejectedSuggestions
          ? { color: 'interaction.suggestion' }
          : null),
      }}
    >
      <ChevronDownIcon boxSize="calc(100% * 2 / 3)" />
    </Center>
  );
};
